import SocialToolbar from "./layout/social-toolbar.js";
import {initSticky, recalcSticky} from "./layout/sticky-kit.js";

Logger.debug('script layout loaded');

/** get main vars */
const app = Voonto.getInstance();
const vocUserPath = app.lookup('vocento.config.nibara').vocUserPath;
if (vocUserPath === undefined) {
    throw 'vocUserPath path in config is empty';
}
const libPath = app.lookup('vocento.config.nibara').libPath;
if (libPath === undefined) {
    throw 'nibara libPath config is empty';
}

/** querystring vars */
function getUrlVars() {
    let vars = [], hash;
    let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

/** btn up */
Voonto.$('.boton.subir').click(function () {
    let target = Voonto.$('[name=' + Voonto.$(this).attr('id') + ']');
    if (target.length) {
        Voonto.$('html,body').animate({
            scrollTop: target.offset().top
        }, 2000);
        return false;
    }
});

/** Menu */
if (Voonto.is.mobile() || Voonto.is.tablet()) {
    Voonto.$('[data-abre-navegacion]').click(function () {
        Voonto.$('.navegacion').stop().animate({left: '0px'}, 350, 'linear');
    });
    Voonto.$('[data-cierra-navegacion]').click(function () {
        let width = Voonto.$('.navegacion').css('width');
        Voonto.$('.navegacion').stop().animate({left: '-' + width}, 350, 'linear');
    });
    Voonto.$('[data-abre-siguiente]').click(function () {
        Voonto.$(this).next().slideToggle();
        Voonto.$(this).toggleClass('rotado');
    });

    if(Voonto.is.tablet()){
          app.load(libPath + 'sticky-kit/sticky-kit.min.js').then(() => {
            Voonto.$('[data-sticky]').stick_in_parent({
              offset_top: 20,
              spacer: false
            });
          });
    }

    // Modulo breaking-news
    Voonto.SocialToolbar = new SocialToolbar();
    let $urgente = Voonto.$('.urgente-teinteresa');
    if ($urgente.length > 0) {
        let $cerrarUrgente = $urgente.find('.cerrar');
        let type = $cerrarUrgente.data('type');
        if (type === 'urgente') {
            if (compruebaCookie()) {
                Logger.info('[Breaking News] urgente hide. Existe cookie');
                $urgente.hide();
            } else {
                Logger.info('[Breaking News] urgente show. No existe cookie');
                $urgente.show();
            }
        } else {
            Logger.info('[Breaking News] urgente show. Existe urgente multiple');
            $urgente.show();
        }

        $cerrarUrgente.click(() => {
            $urgente.hide();
            Voonto.SocialToolbar.enable();

            let type = $cerrarUrgente.data('type');
            if (type === 'te-interesa') {
                return false;
            }

            let src = 'BreakingNews-ABC';
            let content = 'Breaking News - ABC';
            createCookie(src, content);
        });
    }

    Voonto.$('.noticia').click(function () {
        Logger.info('[Breaking News] click noticia');
        let type = Voonto.$(this).data('type');
        if (type === 'urgente') {
            let src = 'BreakingNews-ABC';
            let content = 'Breaking News - ABC';
            createCookie(src, content);
        }

        Logger.info('[Breaking News] type: ', type);

        let href = Voonto.$(this).data('href');
        if(typeof href !== 'undefined') {
          Logger.info('[Breaking News] href: ', href);
          window.location.href = href;
        }
    });

} else {
    if (Voonto.$('.segundo-nivel').length) {
        Voonto.$('.titulo-seccion').css({
            'top': '-112px',
            'opacity': 1
        });
    } else {
        Voonto.$('.titulo-seccion').css('opacity', 1);
    }
    Voonto.$('[data-desplegable-navegacion]').on({
        'mouseenter': function () {
            Voonto.$(this).find('ul').show()
        },
        'mouseleave': function () {
            Voonto.$(this).find('ul').hide()
        }
    });

    app.load(libPath + 'sticky-kit/sticky-kit.min.js').then(() => {
        Voonto.$('[data-sticky]').stick_in_parent({
            offset_top: 20,
            spacer: false
        });
    });

    initSticky();

    Voonto.$(window).on('resize', function () {
        Logger.info('[Sticky] Window Resize');
        recalcSticky();
    });

    Voonto.$('[data-voc-vam]').on('vam:viewable', function () {
        Logger.info('[Sticky] Banner', Voonto.$(this), 'viewable');
        recalcSticky();
    });

    app.on('layout:init-sticky', function() {
        initSticky();
    });

    app.on('layout:recalc-sticky', function() {
        recalcSticky();
    });
}

Voonto.$('[data-cerrar]').click(function () {
    checkCookieLaw();
    Voonto.$(this).parent().hide();
});

/** VocUser */
const vocUserVersion = app.lookup('vocento.config.nibara').vocUserVersion || '201701010101';
Logger.info('Loading vocuser version: ' + vocUserVersion);
app.load(vocUserPath + '/vocento-vocuser-preloader.js?v=' + vocUserVersion);

/** Vam */
const vamPath = app.lookup('vocento.config.nibara').vamPath;
if (vamPath === undefined) {
    throw 'nibara vamPath config is empty';
}
let vamUrl = `${vamPath}/vam.js`;
Logger.info('Loading vam version: ' + vamUrl);
app.load(vamUrl);

/** create cookie function */
function createCookie(src, content = '') {
    Logger.info('[Breaking News] Creo una cookie para un tiempo de vida de 1 hora.');
    // Creo una cookie para un tiempo de vida de 1 hora.
    let date = new Date();
    let minutes = 60;
    date.setTime(date.getTime() + (minutes * 60 * 1000));

    let cookieParameters = {path: '/', expires: date};
    Cookies(src, content, cookieParameters);
}

function compruebaCookie() {
    Logger.info('[Breaking News] compruebaCookie');
    let src = 'BreakingNews-ABC';
    Logger.info('[Breaking News] src: ' + src);
    return !(Cookies(src) === null || Cookies(src) === "" || Cookies(src) === "null" || typeof Cookies(src) === 'undefined');
}

/** header search widget */
Voonto.$(".buscador").on("submit", function (e) {
    let str = Voonto.$(this).find('input').val();
    if (str.length > 0) {
        str = kebabCase(str);
        if (window.location.href.indexOf('lavozdigital.es') > -1) {
            str += '.html';
        }
        let action = Voonto.$(this).attr('action') + str;
        Logger.debug('action: ', action);
        Voonto.$(this).attr('action', action);
    }
    this.submit();
});

function kebabCase(str) {
    let result;

    // Convierte mayus. camelCase a kebab-case.
    result = str.replace(/([a-z][A-Z])/g, function (match) {
        return match.substr(0, 1) + '-' + match.substr(1, 1).toLowerCase();
    });

    result = result.toLowerCase();

    // Convierte no caracteres alfanumericos en '+'
    result = result.replace(/[^-a-z0-9áéíóúàèìòùüÜñÑ]{1}/g, '+');

    return result;
}

/** fake functions to legacy rendered news */
window.lzld = function () {
    return false;
}

window.ads = {
    printAds: function (params) {
        Logger.debug('ads blocked');
        return false;
    }
}

/** tracking sticky mobile buttons */
if (Voonto.is.mobile() || Voonto.is.tablet()) {
    Voonto.$('.publi-sticky.sticky > .botones.cerrar').on('click', function () {
        TagManager.ready.then(function () {
            try {
              /** dejamos desactivado el track hasta que nos confirmen que solo hace falta el atributo en el elmento */
              //  TagManager.set({idCampana: 'cerrarsticky'}).track();
            } catch (e) {
                Logger.error('Error to try track button ', e);
            }
        });

        Voonto.SocialToolbar.enable();
    });

    Voonto.$('.urgente-teinteresa.sticky > .botones.cerrar').on('click', function () {
        TagManager.ready.then(function () {
            try {
              /** dejamos desactivado el track hasta que nos confirmen que solo hace falta el atributo en el elmento */
              //  TagManager.set({idCampana: 'cerrarsticky'}).track();
            } catch (e) {
                Logger.error('Error to try track button ', e);
            }
        });
    });
}

/** tracking up to top button */
Voonto.$('.boton.subir.suave').on('click', function () {
    TagManager.ready.then(function () {
        try {
          /** dejamos desactivado el track hasta que nos confirmen que solo hace falta el atributo en el elmento */
          //  TagManager.set({idCampana: 'subirheader'}).track();
        } catch (e) {
            Logger.error('Error to try track button ', e);
        }
    });
});

/** cookieLaw */
checkCookieLaw();
window.cookieLayerVisto = function () {
    Logger.info('[Cookie Layer] Compruebo cookie aviso de Política de Cookies.');
    checkCookieLaw();
};

function createCookieLaw() {
  if (document.cookie.indexOf("cookie_20170731") === -1) {
    let cookieName = 'cookie_20170731';
    Logger.info('[Cookie Layer] createCookieLaw: ' + cookieName);
    let cookieDate = new Date;
    cookieDate.setFullYear(cookieDate.getFullYear() + 1);
    document.cookie = cookieName + '=visited; expires=' + cookieDate.toGMTString() + ';';
    Voonto.$('.capa-cookies').fadeOut().hide();
  }
}

function checkCookieLaw() {
  Logger.info('[Cookie Layer] checkCookieLaw');
  if (document.cookie.indexOf("cookie_20170731") === -1) {
    let cookieDiv = $('.capa-cookies');
    cookieDiv.show();

    Voonto.$(window).one('mousewheel', function (e) {
      Logger.info('[Cookie Layer] create cookie mousewheel');
      createCookieLaw();
    });

    Voonto.$(window).one('scroll', function (e) {
      Logger.info('[Cookie Layer] create cookie scroll');
      createCookieLaw();
    });

    Voonto.$(window).one('touchmove', function (e) {
      Logger.info('[Cookie Layer] create cookie touchmove');
      createCookieLaw();
    });

    cookieDiv.click(function () {
      Logger.info('[Cookie Layer] create cookie click');
      createCookieLaw();
    });
  }
}

/** Push notifications */
compruebaCookieWebPush();
function compruebaCookieWebPush() {
    Logger.info('[Cookie Notification Push] compruebaCookieWebPush');
    let domain = window.location.hostname;
    let nPunto = (domain.indexOf(".") + 1);
    let src = "wp_" + domain.substring(nPunto);
    src = src.replace('.', '_');
    Logger.info('[Cookie Notification Push] src: ' + src);
    if (Cookies(src) === null || Cookies(src) === "" || Cookies(src) === "null" || typeof Cookies(src) === 'undefined') {
        ActivarWebPush();
    }
}

function crearCookieWebPush() {
    Logger.info('[Cookie Notification Push] crearCookieWebPush');
    let domain = window.location.hostname;
    let nPunto = (domain.indexOf(".") + 1);
    let src = "wp_" + domain.substring(nPunto);
    src = src.replace('.', '_');
    let cookieParameters = {domain: domain, path: '/', expires: 365};
    Cookies(src, "OK", cookieParameters);
}

window.AbrirWebPush = function (pushUrl) {
    Logger.info('[Cookie Notification Push] AbrirWebPush');
    crearCookieWebPush();
    Voonto.$(".contentwebpush").hide();
    window.open(pushUrl, "", "width=600,height=700");
};

window.CerrarWebPush = function () {
    Logger.info('[Cookie Notification Push] CerrarWebPush');
    crearCookieWebPush();
    Voonto.$(".contentwebpush").hide();
};

function isNotNotification() {
    let ua = navigator.userAgent || navigator.vendor || window.opera;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1) || (ua.indexOf("iPhone") > -1) || (ua.indexOf("iPad") > -1) || (ua.indexOf("Apple Computer") > -1);
}

function ActivarWebPush() {
    Logger.info('[Cookie Notification Push] ActivarWebPush');
    if (isNotNotification() === false) {
        let config = {
            medio: window.vocento.config.nibara.media,
            imagen: '//www.abc.es/webpush/img/logo_abc.png',
            alt: 'ABC',
            texto: 'abc.es',
            pushUrl: '//push.abc.es'
        };

        if (config.medio === 'sevilla') {
            config.imagen = '//sevilla.abc.es/webpush/img/logo-sevilla.png';
            config.alt = 'ABC de Sevilla';
            config.texto = 'abcdesevilla.es';
            config.pushUrl = '//push-sevilla.abc.es';
        } else if (config.medio === 'lavoz') {
            config.imagen = '//www.lavozdigital.es/webpush/img/logo-lavozdigital.png';
            config.alt = 'La voz de Cádiz';
            config.texto = 'lavozdigital.es';
            config.pushUrl = '//push.lavozdigital.es';
        }

        let html = ' \
            <div class="contentwebpush"> \
                <img class="logowebpush lzld" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="' + config.imagen + '" alt="' + config.alt + '"> \
                <div class="holawebpush"> \
                <h3>¡Hola!</h3> \
                <p>¿Quieres que ' + config.texto + ' te mantenga informado en todo momento?</p> \
                <fieldset class="ap-customradiowrapwebpush"> \
                    <a class="btn-leftwebpush" href="javascript:void(0)" onclick="window.ns_onclick(this,\'\',\'name=push-permitir&amp;ns_site=abc-es\',\'hidden\');AbrirWebPush(\'' + config.pushUrl + '\');return false;">Permitir</a> \
                    <a class="btn-rightwebpush" href="javascript:void(0)" onclick="window.ns_onclick(this,\'\',\'name=push-bloquear&amp;ns_site=abc-es\',\'hidden\');CerrarWebPush();return false;">No,gracias</a> \
                </fieldset> \
                </div> \
            </div>';
        Voonto.$("body").append(html);
        app.trigger('scroll');
    }
}

/** image lazyload */
Voonto.lazyLoad = new LazyLoad({
  elements_selector: ".lzld",
  data_src: "src"
});

Voonto.$('.lzld-scroll').on('click', function (ev) {
  Voonto.lazyLoad.handleScroll();
});

/** akamai debug */
if (getUrlVars()['akamai_debug'] === '1') {
    Voonto.$('body').prepend('<div style="border: solid 1px red;padding: 21px;">x-akamai-device-characteristics: ' + vocento.tracking.root.akamai_device + '</div>');
}





// WEBPACK FOOTER //
// ./src/scripts/layout-script.js